import Bowser from 'bowser';
import Analytics, { customTrack } from '@cashfree-intl/analytics';
import { CURRENT_NODE_ENV, POSTHOG_API_KEY, POSTHOG_API_HOST } from './env';

import {
  getDeviceId,
  getDeviceIdSource,
  getRequestUrlAndToken,
} from './common';
import { PROD, TRACK_EVENT } from './constants';
// import request from './request';
import Emitter from './emitter';
import EVENTS from '../constants/analytics';

const init = async () => {
  // below methods set deviceid & deviceIdSource to localstorage if not already
  await getDeviceId();
  getDeviceIdSource();
};

const sendEvent = (etype, eventProperties, appType = 'PGDB', email) => {
  if (!etype) return;
  const eventType = `${appType}: ${etype.toLowerCase()}`;

  if (window.Moengage) {
    if (email) {
      window.Moengage.add_email(email);
    }
    window.Moengage.track_event(eventType, eventProperties);
  }
};

const track = async (etype, eprops, apptype = 'PGDB') => {
  if (!etype) return;

  const visitorId = await getDeviceId();
  const browserData = Bowser.parse(window.navigator.userAgent);

  const browserName = browserData.browser.name
    ? browserData.browser.name
    : 'NoBrowser';

  let osName = browserData.os.name ? browserData.os.name : 'NoOS';
  osName = `${browserName}-${osName}`;

  let browserVersion = browserData.browser.version
    ? browserData.browser.version
    : '0.0.1';

  // eslint-disable-next-line prefer-destructuring
  browserVersion = browserVersion.split('.')[0];
  const tracker = {
    user_id: visitorId,
    device_id: visitorId,
    os_name: osName,
    os_version: browserVersion,
    platform: browserData.platform.type
      ? browserData.platform.type
      : 'NoPlatform',
    device_brand: browserData.platform.vendor
      ? browserData.platform.vendor
      : 'NA',
    device_model: browserData.platform.model
      ? browserData.platform.model
      : 'NA',
    language: navigator.language || navigator.userLanguage,
    event_type: `${apptype}: ${etype.toLowerCase()}`,
  };

  if (eprops) {
    tracker.event_properties = eprops;
  }

  // const base64Data = btoa(JSON.stringify(tracker));

  // const url = '/common/events/track';
  // const options = {
  //   method: 'POST',
  //   body: JSON.stringify({
  //     data: base64Data,
  //   }),
  // };

  // try {
  //   await request(url, options);
  // } catch (err) {
  //   // eslint-disable-next-line no-console
  //   console.log(err);
  // }
};

const trackEvent = (etype, eprops, apptype) => () => {
  const { token } = getRequestUrlAndToken();
  if (token) track(etype, eprops, apptype);
  else sendEvent(etype, eprops, apptype);
};

const log = logs => {
  try {
    const base64Data = btoa(JSON.stringify(logs));
    // eslint-disable-next-line no-console
    console.log(base64Data);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Logging disabled', err);
  }
};

const trackEventWithNewNomenclature = ({ eventName, eventProperties = {} }) => {
  const envObj = process.env;
  const isProdEnv = envObj.NODE_ENV === PROD;
  Analytics.track({
    isDebug: !isProdEnv,
    eventName,
    eventProperties,
  });
};

const eventHandler = args => {
  const { token } = getRequestUrlAndToken();
  if (token) track(EVENTS.API_RESPONSE_TIME, args);
  else sendEvent(EVENTS.API_RESPONSE_TIME, args, 'OB');
};

Emitter.on(TRACK_EVENT, eventHandler);

export const initAnalytics = () => {
  Analytics.init({
    product: 'CDB',
    token: null,
    isDebug: true,
    enableNonTokenFlow: true,
    options: {
      posthog: {
        key: POSTHOG_API_KEY,
        host: POSTHOG_API_HOST,
      },
    },
  });
};

const trackWithSDK = (eventName, eventProperties, appType = 'CDB') => {
  /**
   * Adding ":>" in eventName, because when Analytics.track() is used for tracking,
   * it adds ":>" in the event name, hence making sure, the same event gets used in both the flows
   */
  const eventType = `${appType}:> ${eventName.toLowerCase()}`;
  if (!eventName) {
    return;
  }

  /**
   * this internally calls posthog.track()
   */
  customTrack(eventType, {
    ...(eventProperties || {}),
    NODE_ENV: CURRENT_NODE_ENV,
  });
};

export default {
  init,
  track,
  trackEvent,
  sendEvent,
  log,
  trackEventWithNewNomenclature,
  trackWithSDK,
};
